import { useInfiniteQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { DESKTOP_CARDS_COUNT, MOBILE_CARDS_COUNT, QUERY_KEY } from './constants';
import { selectIsDesktop } from '../../selectors/page';
import { fetchEstimationHistory } from '../../services/estimationHistory/fetchEstimationHistory';
import { useApplicationContext } from '../../utils/applicationContext';

/** Запрос за данными ленты прошлых оценок. Поддерживает пагинацию */
export const useEstimationHistoryQuery = () => {
  const context = useApplicationContext();
  const isDesktop = useSelector(selectIsDesktop);
  const resultsOnPage = isDesktop ? DESKTOP_CARDS_COUNT : MOBILE_CARDS_COUNT;

  return useInfiniteQuery(
    QUERY_KEY,
    ({ pageParam }) => fetchEstimationHistory(context, { page: pageParam || 1, perPage: resultsOnPage }),
    {
      staleTime: 120000,
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage || allPages.length * resultsOnPage >= lastPage.totalCount) {
          return undefined;
        }

        return allPages.length + 1;
      },
    },
  );
};
